export const Authenticated = 'authenticated';
export const CSRFTimer = 'csrfTimer';
export const ClientId = 'ExperienceLeague';
export const Close = 'close';
export const CoveoCoachmarkClicked = 'searchPopclick';
export const CoveoCoachmarkDismissed = 'searchPopdismiss';
export const CoveoCoachmarkDisplayed = 'searchPopview';
export const CoveoEmail = 'coveoEmail';
export const CoveoEnableSearch = 'coveoEnableSearch';
export const CoveoOrg = 'adobev2prod9e382h1q';
export const CoveoQuery = 'deferredQuerySuccess';
export const CoveoSearchHubCaseAssist = 'ExperienceLeague_SuggestedSolutions';
export const CoveoSearchHubHomePage = 'experienceleague_supporthomepage';
export const CoveoToken = 'coveoToken';
export const Docs = 'docs';
export const HasECC = 'has_ecc';
export const Error = 'error';
export const FirstRoute = 'firstRoute';
export const Geo = 'geo';
export const HasCommerce = 'has_commerce';
export const HasWorkfront = 'has_workfront';
export const Interactions = 'interactions';
export const JWT = 'jwt';
export const Lang = 'lang';
export const LastRoute = 'lastRoute';
export const LastInvalidRoute = 'search';
export const Learn = 'learn';
export const Microsite = 'microsite';
export const NPS = 'nps';
export const Notice = 'notified';
export const Organization = 'organization';
export const PWAUpdateClosed = 'updateClosed';
export const PreferPortal = 'PreferPortal';
export const ReleaseRegions = 'releaseRegions';
export const PathLevel = 'pathFilterLevel';
export const PathRole = 'pathFilterRole';
export const PathSolution = 'pathFilterSolution';
export const Profile = 'profile';
export const ProfileAttributes = 'attributes';
export const PremiumRedeemResumeUrl = 'premiumRedeemResumeUrl';
export const Ready = 'ready';
export const Recommended = 'recommended';
export const RecommendedID = 'recommendedID';
export const Region = 'region';
export const Route = 'route';
export const ScrollTo = 'scrollto';
export const SelectedOrg = 'current_organization';
export const SelectedProduct = 'selected-product';
export const SolutionLevel = 'solutionLevel';
export const SolutionRole = 'solutionRole';
export const Start = 'start';
export const StreamRetry = 'streamRetry';
export const SupportCaseSubmit = 'supportCaseSubmit';
export const SupportOrgToken = 'supportOrgToken';
export const SupportTab = 'supportTab';
export const SupportVisit = 'supportVisit';
export const Visible = 'visible';
export const Visited = 'visited';
export const Welcomed = 'welcomed';
export const CaseListFilters = 'caseListFilters';
